import React, { Component } from 'react';
import { FindTransactionId } from "../../../api/index";
import Moment from 'react-moment';
import NumberFormat from 'react-number-format';
import { NavLink } from "react-router-dom";
import { Button } from 'reactstrap';

class Invoice extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            data: null,
            date: null,
            isFetching: true,
            listProduct: [],
        };
    }

    fetchData() {
        const transactionId = this.props.match.params.id;
        const content = {
            transactionId: transactionId
        };

        FindTransactionId(content).then(res => {
            this.setState({
                data: {
                    subtotal: res[0].subtotal - res[0].value,
                    id: res[0].id,
                    diskon: res[0].diskon,
                    cashback: res[0].cashback,
                    money_received: res[0].money_received,
                    total: res[0].subtotal,
                    transactionId: res[0].invoiceNumber,
                    createdAt: res[0].createdAt,
                    bank: {
                        bankname: res[0].Bank.bankname,
                        norek: res[0].Bank.norek,
                        image: res[0].Bank.logo,
                        an: res[0].Bank.an,
                    }
                },
                listProduct: res[0].OrderProducts,
                date: res[0].expireDate,
                isFetching: false,
                isLoading: false
            });
        }).catch(err => {
            console.log(err);
        });
    }

    componentDidMount() {
        this.fetchData();
    }

    render() {
        const { isLoading } = this.state;

        return (
            <>
                {!isLoading ? (
                    <div className="invoice-wrapper">
                        <div className="invoice-content">
                            <div className="header">
                                <br />
                                Serambi Botani Kafe<br />
                                 {'  Pasific Place Mall  '}  
                                <br />
                                 0852 1708 0542 
                            </div>
                            <hr />
                            Invoice : {this.state.data.transactionId}
                            <br />
                            <Moment locale="id" format="DD MMM YYYY, HH:mm">{this.state.data.createdAt}</Moment>
                            <hr />
                            {this.state.listProduct.map((value, index) => (
                                <div key={index} style={{ fontSize: '14px' }}>
                                    {value.Product.name} {value.qty} x 
                                    <NumberFormat value={value.price} displayType={'text'} thousandSeparator={true} prefix={'Rp '} />
                                </div>
                            ))}
                            <hr />
                            Subtotal : 
                            <NumberFormat value={this.state.data.subtotal} displayType={'text'} thousandSeparator={true} prefix={'Rp '} />
                            <br />
                            Cash : 
                            <NumberFormat value={this.state.data.money_received} displayType={'text'} thousandSeparator={true} prefix={'Rp '} />
                            <br />
                            Change : 
                            <NumberFormat value={this.state.data.cashback} displayType={'text'} thousandSeparator={true} prefix={'Rp '} />
                            <br />
                            <br />
                            <div>Harga Sudah Termasuk PPN</div>
                            <br />
                            Terima Kasih <br />
                            www.blst.co.id <br />
                            <br />
                        </div>
                        <div className="no-print" onClick={() => window.print()} style={{ width: '100%', textAlign: 'right' }}>
                            <span style={{ cursor: 'pointer' }}>
                                <i className="fa fa-print" style={{ marginRight: '5px' }} aria-hidden="true"></i> Cetak
                            </span> 
                        </div>
                        <br />
                        <div className="no-print" style={{ width: '100%', textAlign: 'right' }}>
                            <NavLink to="/">
                                <Button> Kembali</Button>    
                            </NavLink>
                        </div>
                    </div>
                ) : (
                    <div style={{
                        width: '100%',
                        height: '80vh',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <h1>Generating Invoice...</h1>
                    </div>
                )}
            </>
        );
    }
}

export default Invoice;